import React from 'react'
import PropTypes from 'prop-types'

const SidebarMini = props => {
  return (
    <div>SidebarMini</div>
  )
}

SidebarMini.propTypes = {}

export default SidebarMini